var render = function render(){
  var _vm$product$low_stock;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.product ? _c('ModalContent', {
    attrs: {
      "flat-chrome": "",
      "help-content-id": "popup-product-".concat(_vm.current_entity_profile)
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('template', {
    slot: "content"
  }, [_vm.params.inventoryCreation ? _c('Info', [_vm._v("Ce produit sera créé comme un bien suivi en stock et ajouté immédiatement à l’inventaire.")]) : _vm._e(), _c('div', {
    staticClass: "stitch-modal general-settings-reference product-form"
  }, [!_vm.isOperator ? [_vm.product.archived ? [_c('Warning', {
    attrs: {
      "elevation": 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("archivedProduct")) + " ")])] : _vm._e()] : [_c('Info', {
    attrs: {
      "elevation": 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("productNotOwned")) + " ")])], _c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-shape-outline")]), _c('span', [_vm._v(_vm._s(_vm.$translate("labels.productType")))])], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "product-type-field"
  }, [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.productTypeChoices, function (option) {
    return _c('v-col', {
      key: String(option.value),
      staticClass: "d-flex",
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('button', {
      staticClass: "product-type-option flex-grow-1",
      "class": {
        'product-type-option--selected': _vm.product.is_service === option.value
      },
      attrs: {
        "type": "button",
        "disabled": _vm.product.archived || _vm.isOperator
      },
      on: {
        "click": function click($event) {
          _vm.product.is_service = option.value;
        }
      }
    }, [_c('span', {
      staticClass: "product-type-option__title"
    }, [_vm._v(_vm._s(option.title))]), _c('span', {
      staticClass: "product-type-option__description"
    }, [_vm._v(_vm._s(option.description))])])]);
  }), 1)], 1)])], 1)], 1)], 1), _c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-package-variant-closed")]), _c('span', [_vm._v(_vm._s(_vm.$translate("productInformations")))])], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": _vm.product.provider ? 12 : 6
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.product_saving_errors.name,
      "label": _vm.$translate('labels.name'),
      "placeholder": _vm.$translate('labels.namePlaceholder'),
      "disabled": _vm.product.archived || _vm.isOperator,
      "required": "",
      "dense": "",
      "autofocus": "",
      "hide-details": "auto",
      "outlined": ""
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', [_vm._v(_vm._s(_vm.$translate("labels.name"))), _c('StitchHint', {
          attrs: {
            "hint": _vm.$translate('labels.nameHint')
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 3349583687),
    model: {
      value: _vm.product.name,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "name", $$v);
      },
      expression: "product.name"
    }
  })], 1), !_vm.product.provider ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.product_saving_errors.commercial_name,
      "label": _vm.$translate('labels.commercialName'),
      "placeholder": _vm.$translate('labels.commercialNamePlaceholder'),
      "disabled": _vm.product.archived || _vm.isOperator,
      "dense": "",
      "hide-details": "auto",
      "outlined": ""
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', [_vm._v(_vm._s(_vm.$translate("labels.commercialName"))), _c('StitchHint', {
          attrs: {
            "hint": _vm.$translate('labels.commercialNameHint')
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 1637078023),
    model: {
      value: _vm.product.commercial_name,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "commercial_name", $$v);
      },
      expression: "product.commercial_name"
    }
  })], 1) : _vm._e()], 1), _c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": _vm.product.is_service && _vm.isOperator ? 12 : 6
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.product_saving_errors.upc,
      "label": _vm.$translate('labels.upc'),
      "placeholder": _vm.$translate('labels.upcPlaceholder'),
      "disabled": _vm.product.archived || _vm.isOperator,
      "dense": "",
      "required": "",
      "hide-details": "auto",
      "outlined": ""
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', [_vm._v(_vm._s(_vm.$translate("labels.upc"))), _c('StitchHint', {
          attrs: {
            "hint": _vm.$translate('labels.upcHint')
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 2897974855),
    model: {
      value: _vm.product.upc,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "upc", $$v);
      },
      expression: "product.upc"
    }
  })], 1), !_vm.product.is_service ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.product_saving_errors.manufacturer,
      "label": _vm.$translate('labels.manufacturer'),
      "placeholder": _vm.$translate('labels.manufacturerPlaceholder'),
      "disabled": _vm.product.archived || _vm.isOperator,
      "dense": "",
      "hide-details": "auto",
      "outlined": ""
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', [_vm._v(_vm._s(_vm.$translate("labels.manufacturer"))), _c('StitchHint', {
          attrs: {
            "hint": _vm.$translate('labels.manufacturerHint')
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 1429595015),
    model: {
      value: _vm.product.manufacturer,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "manufacturer", $$v);
      },
      expression: "product.manufacturer"
    }
  })], 1) : _vm._e(), _vm.product.is_service && !_vm.isOperator ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.product.default_unit_purchase_price_excl_vat,
      "error-messages": _vm.product_saving_errors.default_unit_purchase_price_excl_vat,
      "label": _vm.$translate('labels.defaultPurchasePriceExclVat'),
      "placeholder": _vm.$translate('labels.defaultPurchasePriceExclVatPlaceholder'),
      "type": "text",
      "inputmode": "decimal",
      "disabled": _vm.product.archived || _vm.isOperator,
      "dense": "",
      "hide-details": "auto",
      "outlined": ""
    },
    on: {
      "input": function input($event) {
        _vm.product.default_unit_purchase_price_excl_vat = _vm.normalizeDecimalString($event);
      },
      "keydown": _vm.handleKeyPress
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', [_vm._v(_vm._s(_vm.$translate("labels.defaultPurchasePriceExclVat"))), _c('StitchHint', {
          attrs: {
            "hint": _vm.$translate('labels.defaultPurchasePriceExclVatHint')
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 2116677607)
  })], 1) : _vm._e()], 1), !_vm.isOperator && !_vm.product.is_service ? _c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('QuantityUnitInput', {
    attrs: {
      "error-messages": _vm.product_saving_errors.packaging,
      "label": _vm.$translate('labels.packaging'),
      "placeholder": _vm.$translate('labels.packagingPlaceholder'),
      "disabled": _vm.product.archived || _vm.isOperator,
      "hide-details": "auto",
      "outlined": ""
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', [_vm._v(_vm._s(_vm.$translate("labels.packaging"))), _c('StitchHint', {
          attrs: {
            "hint": _vm.$translate('labels.packagingHint')
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 2881657447),
    model: {
      value: _vm.product.packaging,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "packaging", $$v);
      },
      expression: "product.packaging"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.product.default_unit_purchase_price_excl_vat,
      "error-messages": _vm.product_saving_errors.default_unit_purchase_price_excl_vat,
      "label": _vm.$translate('labels.defaultPurchasePriceExclVat'),
      "placeholder": _vm.$translate('labels.defaultPurchasePriceExclVatPlaceholder'),
      "type": "text",
      "inputmode": "decimal",
      "disabled": _vm.product.archived || _vm.isOperator,
      "dense": "",
      "hide-details": "auto",
      "outlined": ""
    },
    on: {
      "input": function input($event) {
        _vm.product.default_unit_purchase_price_excl_vat = _vm.normalizeDecimalString($event);
      },
      "keydown": _vm.handleKeyPress
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', [_vm._v(_vm._s(_vm.$translate("labels.defaultPurchasePriceExclVat"))), _c('StitchHint', {
          attrs: {
            "hint": _vm.$translate('labels.defaultPurchasePriceExclVatHint')
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 2116677607)
  })], 1)], 1) : _vm._e(), !_vm.product.provider && !_vm.isOperator && !_vm.product.archived ? _c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('TagInput', {
    attrs: {
      "object-type": "product",
      "label": _vm.$translate('labels.tags'),
      "placeholder": _vm.$translate('labels.tagsPlaceholder'),
      "dense": true,
      "hide-details": true,
      "outlined": "",
      "error-messages": _vm.product_saving_errors.tags ? [].concat(_vm.product_saving_errors.tags) : []
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.product.tags,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "tags", $$v);
      },
      expression: "product.tags"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), !_vm.product.is_service ? [_c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-format-list-bulleted")]), _c('span', [_vm._v(_vm._s(_vm.$translate("metadataSection")))])], 1), _c('ProductMetadata', {
    key: _vm.product.producttype || 'none',
    staticClass: "product-metadata-fields",
    attrs: {
      "product": _vm.product,
      "producttypes": _vm.producttypes || [],
      "product-saving-errors": _vm.product_saving_errors,
      "disabled-codes": _vm.formatLockedMetadataCodes,
      "outlined": ""
    },
    on: {
      "producttype-changed": _vm.setProductType,
      "metadata-changed": _vm.setMetadata,
      "keydown": _vm.handleKeyPress
    }
  })], 1)], 1)] : _vm._e(), _vm.isCustomer ? [_c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-warehouse")]), _c('span', [_vm._v(_vm._s(_vm.$translate("stockSettings")))])], 1), _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "input-value": _vm.product.stock_tracking || false,
      "label": _vm.$translate('enableStockTracking'),
      "disabled": _vm.product.is_service,
      "error-messages": _vm.product_saving_errors.stock_tracking ? [].concat(_vm.product_saving_errors.stock_tracking) : [],
      "hide-details": "auto",
      "single-line": "",
      "persistent-hint": "",
      "outlined": ""
    },
    on: {
      "change": function change($event) {
        _vm.product.stock_tracking = $event;
        _vm.product.requires_stock_to_be_ordered = false;
        if (!$event) {
          _vm.product.low_stock_alert_treshold = 0;
          if (_vm.product.sale_unit == null) {
            _vm.product.sale_unit = _vm.product.stock_unit || 'pc';
          }
        }
      }
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "disabled": _vm.product.archived || _vm.isOperator || _vm.product.is_service,
      "items": _vm.stockUnitOptions,
      "label": _vm.$translate('labels.stockUnit'),
      "dense": "",
      "hide-details": "auto",
      "outlined": ""
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.product.stock_unit,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "stock_unit", $$v);
      },
      expression: "product.stock_unit"
    }
  })], 1), _vm.showFormatSelect ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('FormatSelect', {
    attrs: {
      "value": _vm.product.format,
      "formats": _vm.formatChoices,
      "label": _vm.$translate('labels.format'),
      "loading": _vm.formatsLoading,
      "disabled": _vm.product.archived || _vm.isOperator || _vm.product.is_service,
      "clearable": "",
      "hide-details": "auto"
    },
    on: {
      "input": _vm.onFormatChange,
      "keydown": _vm.handleKeyPress
    }
  })], 1) : _vm._e(), (_vm.product.stock_unit || 'pc') === 'pc' ? [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.product.piece_content_quantity,
      "error-messages": _vm.product_saving_errors.piece_content_quantity,
      "label": _vm.$translate('labels.pieceContentQuantity'),
      "disabled": _vm.product.archived || _vm.isOperator || _vm.product.is_service || _vm.hasFormat,
      "dense": "",
      "hide-details": "auto",
      "outlined": "",
      "type": "text",
      "inputmode": "decimal"
    },
    on: {
      "input": function input($event) {
        _vm.product.piece_content_quantity = _vm.normalizeDecimalString($event);
      },
      "keydown": _vm.handleKeyPress
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', [_vm._v(_vm._s(_vm.$translate("labels.pieceContentQuantity"))), _c('StitchHint', {
          attrs: {
            "hint": _vm.$translate('labels.pieceContentQuantityHint')
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 1243273447)
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "error-messages": _vm.product_saving_errors.piece_content_unit,
      "items": _vm.pieceContentUnitOptions,
      "label": _vm.$translate('labels.pieceContentUnit'),
      "disabled": _vm.product.archived || _vm.isOperator || _vm.product.is_service || _vm.hasFormat,
      "dense": "",
      "hide-details": "auto",
      "outlined": ""
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.product.piece_content_unit,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "piece_content_unit", $$v);
      },
      expression: "product.piece_content_unit"
    }
  })], 1), _c('v-col', {
    staticClass: "pt-0 pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "text-caption grey--text text--darken-1"
  }, [_vm._v(" " + _vm._s(_vm.$translate("pieceContentExplanation")) + " ")])])] : _vm._e(), _vm.product.stock_tracking ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.product.archived || _vm.isOperator || _vm.product.is_service,
      "value": (_vm$product$low_stock = _vm.product.low_stock_alert_treshold) !== null && _vm$product$low_stock !== void 0 ? _vm$product$low_stock : 0,
      "error-messages": _vm.product_saving_errors.low_stock_alert_treshold,
      "label": _vm.$translate('labels.lowStockAlert'),
      "placeholder": _vm.$translate('labels.lowStockAlertPlaceholder'),
      "dense": "",
      "hide-details": "auto",
      "outlined": "",
      "type": "text",
      "inputmode": "decimal"
    },
    on: {
      "input": function input($event) {
        _vm.product.low_stock_alert_treshold = _vm.normalizeLowStockThreshold($event);
      },
      "keydown": _vm.handleKeyPress
    }
  })], 1) : _vm._e()], 2)], 1)], 1), _c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-cart-outline")]), _c('span', [_vm._v(_vm._s(_vm.$translate("sellSettings")))])], 1), _c('v-checkbox', {
    staticClass: "mt-0 mb-2",
    attrs: {
      "dense": "",
      "input-value": _vm.product.available_for_sale || false,
      "label": _vm.$translate('availableForSale'),
      "hide-details": "",
      "single-line": "",
      "persistent-hint": "",
      "outlined": ""
    },
    on: {
      "change": function change($event) {
        _vm.product.available_for_sale = $event;
      }
    }
  }), _vm.product.available_for_sale ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.vatRate,
      "error-messages": _vm.product_saving_errors.vat_rate,
      "label": _vm.$translate('labels.forceVatRate'),
      "placeholder": _vm.defaultVatRatePlaceholder,
      "type": "text",
      "inputmode": "decimal",
      "disabled": _vm.product.archived || _vm.isOperator,
      "dense": "",
      "hide-details": "auto",
      "outlined": ""
    },
    on: {
      "input": function input($event) {
        _vm.vatRate = _vm.normalizeDecimalString($event);
      },
      "focusout": _vm.saveVatRate,
      "keydown": _vm.handleKeyPress
    }
  })], 1)], 1) : _vm._e(), _vm.product.available_for_sale ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.stockUnitOptionsWithEmpty,
      "label": _vm.$translate('labels.saleUnit'),
      "disabled": _vm.product.archived || _vm.isOperator || _vm.product.is_service,
      "dense": "",
      "hide-details": "auto",
      "outlined": "",
      "clearable": ""
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', [_vm._v(_vm._s(_vm.$translate("labels.saleUnit"))), _c('StitchHint', {
          attrs: {
            "hint": _vm.$translate('labels.saleUnitHint')
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 1580347335),
    model: {
      value: _vm.product.sale_unit,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "sale_unit", $$v);
      },
      expression: "product.sale_unit"
    }
  })], 1), _vm.showSaleFormatSelect ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('FormatSelect', {
    attrs: {
      "value": _vm.product.sale_format,
      "formats": _vm.compatibleSaleFormats,
      "label": _vm.$translate('labels.saleFormat'),
      "loading": _vm.formatsLoading,
      "disabled": _vm.product.archived || _vm.isOperator || _vm.product.is_service,
      "clearable": "",
      "hide-details": "auto"
    },
    on: {
      "input": _vm.onSaleFormatChange,
      "keydown": _vm.handleKeyPress
    }
  })], 1) : _vm._e(), _vm.needsSaleUnitContent ? [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.product.sale_unit_content_quantity,
      "error-messages": _vm.product_saving_errors.sale_unit_content_quantity,
      "label": _vm.$translate('labels.saleUnitContentQuantity'),
      "disabled": _vm.product.archived || _vm.isOperator || _vm.product.is_service || _vm.hasSaleFormat,
      "dense": "",
      "hide-details": "auto",
      "outlined": "",
      "type": "text",
      "inputmode": "decimal"
    },
    on: {
      "input": function input($event) {
        _vm.product.sale_unit_content_quantity = _vm.normalizeDecimalString($event);
      },
      "keydown": _vm.handleKeyPress
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "error-messages": _vm.product_saving_errors.sale_unit_content_unit,
      "items": _vm.saleUnitContentUnitOptions,
      "label": _vm.$translate('labels.saleUnitContentUnit'),
      "disabled": _vm.product.archived || _vm.isOperator || _vm.product.is_service || _vm.hasSaleFormat,
      "dense": "",
      "hide-details": "auto",
      "outlined": ""
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.product.sale_unit_content_unit,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "sale_unit_content_unit", $$v);
      },
      expression: "\n                                            product.sale_unit_content_unit\n                                        "
    }
  })], 1)] : _vm._e()], 2) : _vm._e(), _c('div', {
    staticClass: "product-sell-settings-options mt-2"
  }, [_c('v-checkbox', {
    staticClass: "mt-0 mb-0",
    attrs: {
      "dense": "",
      "label": _vm.$translate('labels.requiresStockOrder'),
      "hide-details": "",
      "single-line": "",
      "persistent-hint": "",
      "outlined": "",
      "disabled": !_vm.product.available_for_sale || !_vm.product.stock_tracking || _vm.product.is_service
    },
    on: {
      "change": function change($event) {
        _vm.product.requires_stock_to_be_ordered = $event;
      }
    },
    model: {
      value: _vm.product.requires_stock_to_be_ordered,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "requires_stock_to_be_ordered", $$v);
      },
      expression: "\n                                    product.requires_stock_to_be_ordered\n                                "
    }
  }), _c('v-checkbox', {
    staticClass: "mt-0 mb-0",
    attrs: {
      "dense": "",
      "input-value": _vm.product.requires_allocation || false,
      "label": _vm.$translate('labels.requiresAllocationOrder'),
      "hide-details": "",
      "single-line": "",
      "persistent-hint": "",
      "outlined": "",
      "disabled": !_vm.product.available_for_sale || _vm.product.is_service
    },
    on: {
      "change": function change($event) {
        _vm.product.requires_allocation = $event;
      }
    }
  })], 1)], 1)], 1), _vm.isNew ? _c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-truck-outline")]), _c('span', [_vm._v(_vm._s(_vm.$translate("suppliersSection")))])], 1), _c('v-row', {
    key: JSON.stringify(_vm.product.providers)
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('ProductProviders', {
    key: JSON.stringify(_vm.product.providers),
    staticClass: "product-provider-fields",
    attrs: {
      "outlined": "",
      "limit": _vm.product.provider ? 1 : null,
      "value": _vm.product.providers || [{}],
      "providers": _vm.providers,
      "editable": _vm.isCustomer,
      "allow-create-provider": _vm.userHasPermission('core.add_provider'),
      "errors": _vm.product_saving_errors.providers
    },
    on: {
      "input": _vm.updateProductProviders,
      "provider-created": _vm.providerCreated
    }
  })], 1)], 1)], 1)], 1) : _vm._e()] : _vm._e()], 2)], 1), _c('template', {
    slot: "bottom"
  }, [!_vm.product.archived ? [_c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto",
    attrs: {
      "text": _vm.$translate('cancel'),
      "ghost": ""
    },
    on: {
      "click": _vm.cancelEditClicked
    }
  }), _c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto ml-sm-3",
    attrs: {
      "text": _vm.saveText,
      "disabled": _vm.product_saving,
      "loading": _vm.product_saving
    },
    on: {
      "click": _vm.saveInformationClicked
    }
  })] : [_c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto",
    attrs: {
      "text": _vm.$translate('close'),
      "ghost": ""
    },
    on: {
      "click": _vm.cancelEditClicked
    }
  })]], 2)], 2) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }